import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReactiveformComponent } from './reactiveform.component';

const routes: Routes = [
  { path: '', component: ReactiveformComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReactiveformRoutingModule { }
